import filesize from "filesize";

import { IAttachment, IDisplayedAttachment } from "./models";

export const generateExistingAttachment = (attachment: IAttachment): IDisplayedAttachment => {
  return {
    ...attachment,
    convertedSize: filesize(attachment.size, { round: 1 }),
    deleting: false,
    fileIconSrc: generateFileImageSrc(getFileExtension(attachment.fileName)),
  };
};

const fileExtensionImageNameMap = {
  gif: "image.svg",
  pdf: "pdf.svg",
  ppt: "presentation.svg",
  pptx: "presentation.svg",
  xls: "spreadsheet.svg",
  xlsx: "spreadsheet.svg",
  txt: "text.svg",
  doc: "text.svg",
  docx: "text.svg",
  zip: "zip.svg",
  mp4: "video.svg",
  mp3: "audio.svg",
  js: "code.svg",
};

const getFileExtension = (fileName: string): string => {
  const i = fileName.lastIndexOf(".");
  return i >= 0 ? fileName.substring(i + 1) : "";
};

const generateFileImageSrc = (extension: string): string => {
  return `/dist/img/files/${fileExtensionImageNameMap[extension] || "generic.svg"}`;
};
